import styled from 'styled-components';

export const TableRowFooter = styled.tr`
  vertical-align: middle;
  height: 90px;
`;
